// extracted by mini-css-extract-plugin
export var marginNegative = "_5e-5 _5e-3 _5e-1";
export var marginPositive = "_5e-4 _5e-3 _5e-1";
export var modalContent = "_5e-6";
export var samplesTable = "_5e-8";
export var samplesTableContainer = "_5e-7";
export var statBox = "_5e-a";
export var tableCell = "_5e-1";
export var tableCellCenter = "_5e-2 _5e-1";
export var tableCellRight = "_5e-3 _5e-1";
export var tableHeader = "_5e-0";
export var trackingNumber = "_5e-9";